import { NotificationsList } from "components/notifications-list";
import { useNotifications, type UseNotifications } from "~/composables/useNotifications";

export const NotificationsWindow = defineComponent<{
  hook?: UseNotifications;
  isActive?: MaybeRef<boolean>;
}>((props) => {
  const hook = props.hook || useNotifications();
  const isActive = computed(() => unref(props.isActive));

  return () => {
    return <div
      class="w-[400px] h-[400px] bg-white overflow-hidden rounded-2xl border border-slate-900/[0.07] shadow-[inset_0_1px_0_rgba(255,255,255,0.9),0_1px_2px_rgba(15,23,42,0.06),0_12px_28px_-8px_rgba(15,23,42,0.18),0_32px_64px_-16px_rgba(30,41,99,0.14)]"
    >
      <NotificationsList hook={hook} isActive={isActive.value}/>
    </div>;
  }
}, { props: ['hook', 'isActive'] });
